import AnnotationsHandler from '..';
import AnnotationProcessor from '../processor';
import { C11nEnv } from '../../interpreter/c11n-env';

interface DataSourceRecord {
  [key: string]: string | number | boolean | null | undefined;
}

AnnotationsHandler.registerHandler('@DATASOURCE', (value: string, c11nEnv: C11nEnv) => {
  const actualDPResult = c11nEnv.getSharedDataPageForReferenceList() || c11nEnv.getValue(value) || [];
  const componentConfig = c11nEnv.getComponentConfig();
  const datasourceProperty = Object.keys(componentConfig).find((key) => componentConfig[key]?.source?.includes(value));

  if (datasourceProperty) {
    const { fields, copyAll, filterDownloadedFields } = componentConfig[datasourceProperty];
    const resolveResult: DataSourceRecord[] = [];
    actualDPResult.forEach((record: DataSourceRecord) => {
      const resolvedRecord: DataSourceRecord = {};
      if (copyAll || filterDownloadedFields) {
        Object.keys(record).forEach((recordPropKey) => {
          const recordPropName = AnnotationProcessor.getPropertyName(recordPropKey);
          resolvedRecord[recordPropName] = record[recordPropName];
        });
      } else {
        Object.keys(fields).forEach((key) => {
          const propName = AnnotationProcessor.getPropertyName(fields[key]);
          resolvedRecord[key] = record[propName];
        });
      }
      resolveResult.push(resolvedRecord);
    });
    return resolveResult;
  }
  return [];
});
